module.exports = __webpack_public_path__ + "static/media/LMBCLogo.342e9bf6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/img/LMBCLogo.webp
// module id = 113
// module chunks = 0